/* esm.sh - esbuild bundle(@internetarchive/reviews@1.0.2) esnext production */
import{__decorate as n}from"/v135/tslib@2.8.1/esnext/tslib.mjs";import{html as l,css as U,LitElement as q,nothing as b}from"/v135/lit@2.8.0/esnext/lit.mjs";import{property as c,customElement as V,state as w,query as X}from"/v135/lit@2.8.0/esnext/decorators.js";import{msg as d}from"/v135/@lit/localize@0.12.2/esnext/localize.mjs";import{unsafeHTML as Z}from"/v135/lit@2.8.0/esnext/directives/unsafe-html.js";import J from"/v135/dompurify@3.2.5/esnext/dompurify.mjs";import{iaButtonStyles as K}from"/v135/@internetarchive/ia-styles@1.0.0/esnext/ia-styles.mjs";import"/v135/@internetarchive/ia-activity-indicator@0.0.6/esnext/ia-activity-indicator.mjs";import{IaFetchHandler as Q}from"/v135/@internetarchive/fetch-handler-service@1.0.1/esnext/fetch-handler-service.mjs";import{Review as Y}from"/v135/@internetarchive/metadata-service@1.0.4/esnext/metadata-service.mjs";import{svg as M}from"/v135/lit@2.8.0/esnext/lit.mjs";var k=M`
  <svg class="star-selected" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
  <path
    d="m81.0388846 100-30.9636029-22.5595033-30.7410319 22.5595033 10.6670595-37.3922042-30.0013093-25.2155916h37.5556428l12.5196389-37.3922042 12.3690754 37.3922042h37.5556429l-29.7034563 25.2155916z"
    fill="#c2820a"
    stroke="#c2820a"
    stroke-width="3px"
  />
</svg>`;import{svg as A}from"/v135/lit@2.8.0/esnext/lit.mjs";var E=A`
  <svg class="star-unselected" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
  <path
    d="m81.0388846 100-30.9636029-22.5595033-30.7410319 22.5595033 10.6670595-37.3922042-30.0013093-25.2155916h37.5556428l12.5196389-37.3922042 12.3690754 37.3922042h37.5556429l-29.7034563 25.2155916z"
    fill="#ffffff"
    stroke="#c2820a"
    stroke-width="3px"
  />
</svg>`;import{__decorate as m}from"/v135/tslib@2.8.1/esnext/tslib.mjs";import{html as h,css as z,LitElement as G,nothing as g}from"/v135/lit@2.8.0/esnext/lit.mjs";import{property as f,customElement as F,state as B}from"/v135/lit@2.8.0/esnext/decorators.js";import{msg as v}from"/v135/@lit/localize@0.12.2/esnext/localize.mjs";import{unsafeHTML as W}from"/v135/lit@2.8.0/esnext/directives/unsafe-html.js";import{svg as D}from"/v135/lit@2.8.0/esnext/lit.mjs";var _=D`
  <svg class="star-basic" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
  <path
    d="m81.0388846 100-30.9636029-22.5595033-30.7410319 22.5595033 10.6670595-37.3922042-30.0013093-25.2155916h37.5556428l12.5196389-37.3922042 12.3690754 37.3922042h37.5556429l-29.7034563 25.2155916z"
    fill="2C2C2C"
  />
</svg>`;import{html as I}from"/v135/lit@2.8.0/esnext/lit.mjs";function S(i=""){if(i.length<=40)return i;let t=i.substring(0,40)+"...";return I`<span title="${i}">${t}</span>`}import j from"/v135/dompurify@3.2.5/esnext/dompurify.mjs";var H=["a"];function $(i){return j.addHook("afterSanitizeAttributes",e=>{e.nodeName.toLowerCase()==="a"&&(e.setAttribute("rel","ugc nofollow"),e.setAttribute("target","_blank"))}),j.sanitize(i,{ALLOWED_TAGS:H})}function x(i,e=100,t=!0){if(i.length<e)return i;let r=e;if(t){let a=i.indexOf(" ",e),s=a-e<=20;if(s&&a===i.length-1)return i;a!==-1&&s&&(r=a)}return P(i,r,e)}function P(i,e,t){let r=i.slice(0,e),a=r.match(/<a/gi);if(a){let s=r.match(/<\/a/gi);if(!s||s.length<a.length){let p=i.indexOf("</a>",e),y=p-t<=20;if(y&&i.length===p+4)return i;if(p!==-1&&y)r=i.slice(0,p+4);else{let T=r.lastIndexOf("<a");r=i.slice(0,T)}}}return r.concat("...")}var O=/(http(s)?)?(:\/\/)?([a-zA-Z][-a-z0-9]*(\.[-a-z0-9]+)+(\/[^\s\?#<]*)*(\?[^\s#]*)?(#[^\s]*)?)/;function R(i){return i.replace(/(?<=href=")[^"]+(?=")/,r=>r.replace(".","__DOT__")).replace(O,r=>r=`<a href="${r.match(/^(https|http)/)?r:"https://"+r}" rel="ugc nofollow" target="_blank">${r}</a>`).replace("__DOT__",".")}function L(i){return i.trim().replace(/[ |\t]+/g," ").replace(/[\n|\r\n]+/g,"<br />").replace(/(<br[^>]*>(<\/br>)?)+/g,"<br />")}import{svg as N}from"/v135/lit@2.8.0/esnext/lit.mjs";var C=N`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" class="delete-icon">
    <rect width="24" height="24" fill="white"/>
    <path d="M5 7.5H19L18 21H6L5 7.5Z" stroke="#000000" stroke-linejoin="round"/>
    <path d="M15.5 9.5L15 19" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 9.5V19" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.5 9.5L9 19" stroke="#000000" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M16 5H19C20.1046 5 21 5.89543 21 7V7.5H3V7C3 5.89543 3.89543 5 5 5H8M16 5L15 3H9L8 5M16 5H8" stroke="#000000" stroke-linejoin="round"/>
  </svg>
`;var u=class extends G{constructor(){super(...arguments),this.maxSubjectLength=100,this.maxBodyLength=150,this.baseHost="https://archive.org",this.canDelete=!1,this.showTruncatedContent=!1,this.deleteMsg=""}render(){return this.review?h`
          <article class="review" id=${this.generateDomId()}>
            ${this.canDelete?h`
                  <button
                    class="delete-btn"
                    title="Delete this review"
                    @click=${this.deleteReview}
                  >
                    ${C}
                  </button>
                `:g}
            <div class="top-line">
              <b>${v("Reviewer:")}</b> ${this.reviewerTemplate} -
              ${this.starsTemplate}${this.createDateTemplate}
            </div>
            <div class="subject">
              <b>${v("Subject: ")}</b>${this.subjectTemplate}
            </div>
            <div class="body">
              ${this.deleteMsg?h`<i>${v(this.deleteMsg)}</i>`:this.bodyTemplate}
            </div>
            ${this.truncationButtonsTemplate}
          </article>
        `:h`
          <div class="error">
            ${v("This review cannot be displayed at this time.")}
          </div>
        `}get subjectTemplate(){var e;return!((e=this.review)===null||e===void 0)&&e.reviewtitle?this.review.reviewtitle.length<=this.maxSubjectLength||this.showTruncatedContent?this.review.reviewtitle:x(this.review.reviewtitle,this.maxSubjectLength):""}get bodyTemplate(){var e;if(!(!((e=this.review)===null||e===void 0)&&e.reviewbody))return g;let t=$(this.review.reviewbody),r=t.length<=this.maxBodyLength||this.showTruncatedContent?t:x(t,this.maxBodyLength);return h`${W(this.prepReview(r))}`}get truncationButtonsTemplate(){var e,t;return!(!((e=this.review)===null||e===void 0)&&e.reviewtitle)||!(!((t=this.review)===null||t===void 0)&&t.reviewbody)?g:this.review.reviewtitle.length<=this.maxSubjectLength&&this.review.reviewbody.length<=this.maxBodyLength?g:this.showTruncatedContent?this.lessButtonTemplate:this.moreButtonTemplate}get moreButtonTemplate(){return h`
      <button
        class="simple-link more-btn"
        @click=${()=>this.showTruncatedContent=!0}
      >
        ${v("More...")}
      </button>
    `}get lessButtonTemplate(){return h`<button
      class="simple-link less-btn"
      @click=${()=>this.showTruncatedContent=!1}
    >
      ${v("...Less")}
    </button>`}get reviewerTemplate(){return this.review?this.review.reviewer_itemname?h`
            <a
              href="${this.baseHost}/details/${this.review.reviewer_itemname}"
              class="reviewer-link simple-link"
              data-event-click-tracking="ItemReviews|ReviewerLink"
            >
              ${S(this.review.reviewer)}
            </a>
          `:h`${S(this.review.reviewer)}`:g}get starsTemplate(){return!this.review||!this.review.stars?g:h`
      <div
        class="review-stars"
        title="${v(`${this.review.stars} out of 5 stars`)}"
      >
        ${new Array(Number(this.review.stars)).fill(null).map(()=>h`<div class="review-star">${_}</div>`)}
      </div>
      -
    `}get createDateTemplate(){var e,t;if(!(!((e=this.review)===null||e===void 0)&&e.createdate)||!(!((t=this.review)===null||t===void 0)&&t.reviewdate))return g;let r=new Date(this.review.reviewdate),a=new Date(this.review.createdate),s=a.toLocaleString("en-us",{month:"long",day:"numeric",year:"numeric"}),p=r.getTime()!==a.getTime()?"(edited)":"";return v(`${s} ${p}`)}generateDomId(){var e;return!((e=this.review)===null||e===void 0)&&e.createdate?`review-${Date.parse(this.review.createdate.toString())}`:""}prepReview(e){return L(R(e))}async deleteReview(){if(!this.review||!this.identifier||!confirm(v("Are you sure you want to delete this review?")))return;let e=`${this.baseHost}/edit-reviews.php?identifier=${this.identifier}&deleteReviewer=${this.review.reviewer}`;try{await fetch(e,{method:"POST"}),this.deleteMsg="This review has been queued for deletion."}catch{this.deleteMsg="Sorry, we were unable to delete this review."}}static get styles(){return z`
      :host {
        font-family: var(
          --ia-font-stack,
          'Helvetica Neue',
          Helvetica,
          Arial,
          sans-serif
        );

        font-size: inherit;
        --container-bg-color: #fbfbfd;
        --container-border-color: #999999;
      }

      .review {
        position: relative;
        padding-right: 30px;
      }

      .error {
        color: var(--error-color, #cc0000);
      }

      .top-line {
        margin-bottom: 0.5rem;
      }

      .top-line > * {
        display: inline-block;
      }

      .review-star {
        width: 1rem;
        display: inline-block;
      }

      .simple-link,
      .body a {
        color: var(--link-color, #4b64ff);
        text-decoration: none;
        background: transparent;
        border: none;
        padding: 0px;
      }

      .simple-link:hover,
      .body a:hover {
        cursor: pointer;
        text-decoration: underline;
      }

      .subject {
        margin-bottom: 0.5rem;
      }

      .delete-btn {
        position: absolute;
        top: 0;
        right: 0;
        padding: 0;
        background: none;
        border: 0;
      }

      .delete-btn:hover {
        cursor: pointer;
      }

      .delete-icon {
        width: 20px;
        mix-blend-mode: multiply;
      }
    `}};m([f({type:Object})],u.prototype,"review",void 0);m([f({type:String})],u.prototype,"identifier",void 0);m([f({type:Number})],u.prototype,"maxSubjectLength",void 0);m([f({type:Number})],u.prototype,"maxBodyLength",void 0);m([f({type:String})],u.prototype,"baseHost",void 0);m([f({type:Boolean})],u.prototype,"canDelete",void 0);m([B()],u.prototype,"showTruncatedContent",void 0);m([B()],u.prototype,"deleteMsg",void 0);u=m([F("ia-review")],u);var o=class extends q{constructor(){super(...arguments),this.token="",this.baseHost="https://archive.org",this.endpointPath="/write-review.php",this.displayMode="form",this.submitterScreenname="Anonymous",this.fetchHandler=new Q,this.bypassRecaptcha=!1,this.canDelete=!1,this.currentStars=0,this.currentSubjectLength=0,this.currentBodyLength=0,this.formCanSubmit=!1,this.submissionInProgress=!1,this.RECAPTCHA_ERROR_MESSAGE="Could not validate review. Please try again later.",this.GENERIC_ERROR_MESSAGE="There's been a temporary error. Please wait a moment and try again."}render(){return this.displayMode==="review"?this.reviewTemplate:l`<form id="review-form" @submit=${this.handleSubmit}>
          ${this.unrecoverableError?this.unrecoverableErrorTemplate:l`
                <span class="inputs">
                  ${this.starsInputTemplate} ${this.subjectInputTemplate}
                  ${this.bodyInputTemplate} ${this.hiddenInputsTemplate}
                </span>
              `}
          ${this.recoverableErrorTemplate} ${this.actionButtonsTemplate}
        </form>`}firstUpdated(){this.formCanSubmit=this.checkSubmissionAllowed()}updated(e){e.has("oldReview")&&this.oldReview&&(this.oldReview.stars&&(this.currentStars=this.oldReview.stars),this.oldReview.reviewtitle&&(this.currentSubjectLength=this.oldReview.reviewtitle.length),this.oldReview.reviewbody&&(this.currentBodyLength=this.oldReview.reviewbody.length)),e.has("recaptchaManager")&&!this.bypassRecaptcha&&this.recaptchaManager&&!this.unrecoverableError&&this.setupRecaptcha(),(e.has("currentSubjectLength")||e.has("currentBodyLength"))&&(this.formCanSubmit=this.checkSubmissionAllowed())}get reviewTemplate(){return this.oldReview?l`
      <div class="review-container">
        <ia-review
          .identifier=${this.identifier}
          .review=${this.oldReview}
          .baseHost=${this.baseHost}
          ?canDelete=${this.canDelete}
        ></ia-review>
      </div>
    `:b}get unrecoverableErrorTemplate(){return this.unrecoverableError?l`
          <div class="unrecoverable-error">
            <span class="error-msg">${d(this.unrecoverableError)}</span>
          </div>
        `:b}get recoverableErrorTemplate(){return this.recoverableError?l`
          <div class="recoverable-error">
            ${Z(this.sanitizeErrorMsg(d(this.recoverableError)))}
          </div>
        `:b}get starsInputTemplate(){return l`
      <div class="form-heading rating">
        <label for="stars-field">${d("Rating (optional)")}</label>
      </div>
      <input
        type="hidden"
        name="field_stars"
        id="stars-input"
        .value=${this.currentStars.toString()}
        required
      />
      <div class="stars">
        ${[1,2,3,4,5].map(e=>this.renderStar(e))}
        <button
          type="button"
          class="clear-stars-btn"
          @click=${this.handleClearBtnClicked}
        >
          ${d("Clear")}
        </button>
      </div>
    `}get subjectInputTemplate(){var e,t;return l`
      <span id="subject-input" class="input-box ${this.maxSubjectLength&&this.currentSubjectLength>this.maxSubjectLength?"error":""}"
      ><div class="form-heading">
        <label for="field_reviewtitle">${d("Subject")}</label>
        ${this.maxSubjectLength?l`<div class="char-count subject">
                ${this.currentSubjectLength}/${this.maxSubjectLength}
              </div>`:b}
      </div>
      <input
        type="text"
        name="field_reviewtitle"
        id="field_reviewtitle"
        .value=${(t=(e=this.oldReview)===null||e===void 0?void 0:e.reviewtitle)!==null&&t!==void 0?t:""}
        @input=${this.handleSubjectChanged}
        required
    />${this.maxSubjectLength?l`
            <div class="input-error">
              ${d(`Subject may only have ${this.maxSubjectLength} characters`)}
            </div>
          `:b}</div></span>
    `}get bodyInputTemplate(){var e,t;return l`
      <span
        id="body-input"
        class="input-box ${this.maxBodyLength&&this.currentBodyLength>this.maxBodyLength?"error":""}"
        ><div class="form-heading">
          <label for="field_reviewbody">${d("Review")}</label>
          ${this.maxBodyLength?l`<div class="char-count body">
                ${this.currentBodyLength}/${this.maxBodyLength}
              </div>`:b}
        </div>
        <textarea
          name="field_reviewbody"
          id="field_reviewbody"
          .value=${(t=(e=this.oldReview)===null||e===void 0?void 0:e.reviewbody)!==null&&t!==void 0?t:""}
          rows="10"
          cols="50"
          required
          @input=${this.handleBodyChanged}
        ></textarea>
        ${this.maxBodyLength?l`
              <div class="input-error">
                ${d(`Review may only have ${this.maxBodyLength} characters`)}
              </div>
            `:b}
      </span>
    `}get hiddenInputsTemplate(){return l`
      <input type="hidden" name="field_reviewtoken" .value=${this.token} />
      ${this.identifier?l`<input
            type="hidden"
            name="identifier"
            .value=${this.identifier}
          />`:b}
    `}get actionButtonsTemplate(){return l`<div class="action-btns">
      <button
        type="button"
        class="ia-button dark"
        data-testid="cancel-btn"
        @click=${()=>this.displayMode="review"}
      >
        ${d("Cancel")}
      </button>
      <button
        type="submit"
        class="ia-button primary"
        name="submit"
        ?disabled=${!this.formCanSubmit||this.submissionInProgress}
      >
        ${this.submissionInProgress?l`
              <span class="loading-indicator" alt="Loading indicator">
                <ia-activity-indicator></ia-activity-indicator>
              </span>
            `:d("Submit review")}
      </button>
    </div>`}renderStar(e){let t=e===this.currentStars,r=d(`Rate ${e>1?`${e} stars`:"1 star"}`);return l`
      <button
        class="star star-${e}"
        title=${t?d("Clear rating"):r}
        @click=${a=>this.handleStarClicked(a,e)}
      >
        ${e<=this.currentStars?k:E}
      </button>
    `}async setupRecaptcha(){var e;try{this.recaptchaWidget=await((e=this.recaptchaManager)===null||e===void 0?void 0:e.getRecaptchaWidget())}catch{this.unrecoverableError=this.RECAPTCHA_ERROR_MESSAGE}}sanitizeErrorMsg(e){return J.sanitize(e,{ALLOWED_TAGS:["a","b","br"]})}async handleSubmit(e){var t;if(e.preventDefault(),!(!this.formCanSubmit||this.submissionInProgress)){if(this.submissionInProgress=!0,this.recoverableError="",!this.reviewForm.reportValidity())return this.stopSubmission();try{let r=new URLSearchParams;if(!this.bypassRecaptcha){let s=await this.getRecaptchaToken();if(!s)return this.handleRecaptchaError();r.append("g-recaptcha-response",s??"")}for(let s of new FormData(this.reviewForm))r.append(s[0],s[1]);r.append("submitter","review-form");let a=await this.fetchHandler.fetchApiResponse(`${this.baseHost}${this.endpointPath}`,{method:"POST",includeCredentials:!0,body:r});a?.success===!0?(this.submissionInProgress=!1,this.oldReview=this.generateSubmittedReview(),this.displayMode="review"):(this.recoverableError=(t=a.error)!==null&&t!==void 0?t:this.GENERIC_ERROR_MESSAGE,this.stopSubmission())}catch(r){console.error(r),this.recoverableError=this.GENERIC_ERROR_MESSAGE,this.stopSubmission()}}}generateSubmittedReview(){var e,t,r,a,s,p;let y=new Date().toDateString();return new Y({reviewtitle:this.reviewForm.field_reviewtitle.value,reviewbody:this.reviewForm.field_reviewbody.value,stars:this.reviewForm.field_stars.value,reviewdate:y,reviewer:(t=(e=this.oldReview)===null||e===void 0?void 0:e.reviewer)!==null&&t!==void 0?t:this.submitterScreenname,reviewer_itemname:(a=(r=this.oldReview)===null||r===void 0?void 0:r.reviewer_itemname)!==null&&a!==void 0?a:this.submitterItemname,createdate:(p=this.dateToString((s=this.oldReview)===null||s===void 0?void 0:s.createdate))!==null&&p!==void 0?p:y})}dateToString(e){return e instanceof Date?e.toDateString():e}async getRecaptchaToken(){if(!this.recaptchaWidget){this.handleRecaptchaError();return}try{return await this.recaptchaWidget.execute()}catch{this.handleRecaptchaError();return}}handleRecaptchaError(){this.recoverableError=this.RECAPTCHA_ERROR_MESSAGE,this.stopSubmission()}stopSubmission(){this.submissionInProgress&&(this.submissionInProgress=!1)}handleStarClicked(e,t){e.preventDefault(),this.setStars(t)}handleClearBtnClicked(e){e.preventDefault(),this.currentStars=0}setStars(e){this.currentStars=e===this.currentStars?0:e}handleSubjectChanged(e){let t=e.target;this.currentSubjectLength=t.value.length}handleBodyChanged(e){let t=e.target;this.currentBodyLength=t.value.length}checkSubmissionAllowed(){return!(this.unrecoverableError||!this.currentBodyLength||!this.currentSubjectLength||this.maxSubjectLength&&this.currentSubjectLength>this.maxSubjectLength||this.maxBodyLength&&this.currentBodyLength>this.maxBodyLength)}static get styles(){return[K,U`
        :host {
          font-family: var(
            --ia-font-stack,
            'Helvetica Neue',
            Helvetica,
            Arial,
            sans-serif
          );

          color: var(--ia-text-color, #2c2c2c);

          --container-error-color: #ea0202;
          --container-link-color: #4f65f5;
          --container-bg-color: #fbfbfd;
          --container-border-color: #999999;
        }

        ia-review {
          --error-color: var(--container-error-color, #ea0202);
          --link-color: var(--container-link-color, #4f65f5);
        }

        form,
        .review-container {
          border: 2px solid var(--container-border-color, #999999);
          border-radius: 5px;
          background-color: var(--container-bg-color, #fbfbfd);
          padding: 10px;
          margin-bottom: 20px;
        }

        .form-heading {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          padding-top: 15px;
        }

        .form-heading.rating {
          padding-top: 0;
        }

        .form-heading label {
          font-size: 1.6rem;
          font-weight: bold;
        }

        label {
          display: inline-block;
          margin-bottom: 5px;
        }

        textarea,
        input[type='text'],
        .unrecoverable-error {
          padding: 5px;
          width: calc(100% - 10px);
          font-family: inherit;
          border-radius: 5px;
          border: 1px solid var(--container-border-color, #999999);
        }

        .input-box.error input,
        .input-box.error textarea {
          border: 2px solid var(--container-error-color, #ea0202);
        }

        .input-box.error .char-count,
        .input-error,
        .unrecoverable-error,
        .recoverable-error {
          color: var(--container-error-color, #ea0202);
        }

        .input-error {
          display: none;
        }

        .input-box.error .input-error {
          display: block;
          text-align: right;
          padding-top: 5px;
        }

        .stars {
          display: flex;
          flex-direction: row;
          gap: 2px;
          align-items: center;
        }

        .star {
          all: unset;
          height: 30px;
          width: 30px;
        }

        .star:hover {
          cursor: pointer;
        }

        .clear-stars-btn,
        .recoverable-error a {
          padding: 0 5px;
          color: var(--container-link-color, #4f65f5);
          font-family: inherit;
          border: none;
          background: transparent;
          display: inline-block;
          padding-top: 5px;
        }

        .clear-stars-btn:hover,
        .recoverable-error a:hover {
          cursor: pointer;
          text-decoration: underline;
        }

        .action-btns {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          gap: 10px;
          padding-top: 15px;
        }

        .ia-button:disabled {
          opacity: 0.75;
        }

        .ia-button:disabled:hover {
          cursor: not-allowed;
        }

        .unrecoverable-error {
          min-height: 50px;
          padding: 5px;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          background-color: var(--container-bg-color, #fbfbfd);
        }

        .loading-indicator {
          display: block;
          width: 20px;
          height: 20px;
          margin-top: 2px;
          --activityIndicatorLoadingRingColor: #fff;
          --activityIndicatorLoadingDotColor: #fff;
        }

        @media only screen and (max-width: 350px) {
          .action-btns {
            flex-direction: column-reverse;
            align-items: center;
          }
        }
      `]}};n([c({type:String})],o.prototype,"identifier",void 0);n([c({type:String})],o.prototype,"token",void 0);n([c({type:String})],o.prototype,"baseHost",void 0);n([c({type:String})],o.prototype,"endpointPath",void 0);n([c({type:String})],o.prototype,"displayMode",void 0);n([c({type:String})],o.prototype,"submitterScreenname",void 0);n([c({type:String})],o.prototype,"submitterItemname",void 0);n([c({type:Object})],o.prototype,"oldReview",void 0);n([c({type:String})],o.prototype,"unrecoverableError",void 0);n([c({type:Number})],o.prototype,"maxSubjectLength",void 0);n([c({type:Number})],o.prototype,"maxBodyLength",void 0);n([c({type:Object})],o.prototype,"fetchHandler",void 0);n([c({type:Object})],o.prototype,"recaptchaManager",void 0);n([c({type:Boolean})],o.prototype,"bypassRecaptcha",void 0);n([c({type:Boolean})],o.prototype,"canDelete",void 0);n([w()],o.prototype,"currentStars",void 0);n([w()],o.prototype,"currentSubjectLength",void 0);n([w()],o.prototype,"currentBodyLength",void 0);n([w()],o.prototype,"recoverableError",void 0);n([w()],o.prototype,"formCanSubmit",void 0);n([w()],o.prototype,"submissionInProgress",void 0);n([X("#review-form")],o.prototype,"reviewForm",void 0);o=n([V("ia-review-form")],o);export{o as ReviewForm};
//# sourceMappingURL=reviews.mjs.map